import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useRouter } from "next/router";
import { getProposalData as getProposalDataRequest } from "@store/moData/proposalData/actions";
import { getMMVDataRequest } from "@store/mmvData/actions";
import { mmvFlowInitiated } from "@analytics/car/actions/landing";
import { MMVHookArgs, VehicleDataHookArgs } from "../types.d";
import { useSelector } from "react-redux";
import { getCurrentTermYearAndDiff } from "./utils";
import { getNoOptionRanges } from "./utils";
import metaDataNew from "@utils/metaData";
const ncbMeta = metaDataNew.ncb;
import { JourneyMetaOption } from "../types.d";
import { setSessionStorage } from "@utils/index";
// import { newCarComprehensiveBasePathHi } from "@utils/landing-page-config";
const useOnMount = ({ proposalDataSuccess, queryProposalId }: any) => {
  const dispatch = useDispatch();
  const router = useRouter();
  const { query } = router;
  const { cardType } = query;
  useEffect(() => {
    // get proposal data if query param contains proposalId but data is not fectched.
    if (queryProposalId && (!proposalDataSuccess || cardType === "nsr")) {
      dispatch(
        getProposalDataRequest({
          proposalId: queryProposalId,
          updateNavigation: true,
          state: "preQuote",
          replacePath: cardType === "nsr",
          // shouldPoll: cardType === "nsr"
          shouldPoll: false,
          setPrequote: cardType === "nsr",
          callback: callbackData => {
            const carNumber = callbackData?.data?.carNumber;
            const proposalId = callbackData?.proposalId;
            const mmv_version = callbackData?.data?.mmv_version;

            setSessionStorage("mmv_version", mmv_version);

            if (window?.wisepops && carNumber && cardType === "nsr") {
              window?.wisepops("properties", {
                registrationNumber: carNumber,
                proposalId
              });
            }
          }
        })
      );
      // window.basePath !== newCarComprehensiveBasePathHi &&
      //   sessionStorage.setItem("journey", "v0");
    }
  }, [cardType]);
};

const useInitialLoading = ({
  prevShowLoader,
  showLoader,
  interactionEnabled,
  setInteractionEnabled,
  initialLoadingFinished,
  dispatch
}) => {
  useEffect(() => {
    if (!interactionEnabled) {
      dispatch(initialLoadingFinished());
      // track(analytics.initialLoadingFinished);
      setInteractionEnabled(true);
    }
  }, [prevShowLoader, showLoader]);
};

// ************* //

// This function is being used. We can remove this

export const mmvUseEffectHook = ({ carNumber, selectedValue }) => {
  const dispatch = useDispatch();
  useEffect(() => {
    if (!carNumber && !selectedValue.make) {
      dispatch(mmvFlowInitiated());
    }
  }, []);
};

export const useMMVData = ({ mmvSuccess, dispatch }: MMVHookArgs) => {
  useEffect(() => {
    if (!mmvSuccess) {
      dispatch(getMMVDataRequest());
    }
  }, []);
};

export const useVehicleData = ({
  make,
  model,
  variant,
  setMake,
  setModel,
  setVariant
}: VehicleDataHookArgs) => {
  useEffect(() => {
    if (make?.name) {
      setMake(make);
    }

    if (model) {
      setModel(model);
    }

    if (variant?.name) {
      setVariant(variant);
    }
  }, [make?.name, variant?.name]);
};

const useIntersect = ({ ref, observer, setisComponentLoaded }: any) => {
  const options: any = {
    root: null,
    rootMargin: "70px",
    threshold: 0
  };

  useEffect(() => {
    if (window.IntersectionObserver) {
      const target: any = ref.current;
      if (observer.current) observer.current.disconnect();
      const callback = ({ entries }: any) => {
        entries.forEach(entry => {
          if (entry.intersectionRatio) {
            setisComponentLoaded(true);
          }
        });
      };
      // eslint-disable-next-line no-param-reassign
      observer.current = new window.IntersectionObserver(
        entries => callback({ entries }),
        options
      );
      const { current } = observer;
      current.observe(target);
      return () => {
        if (current) current.disconnect();
      };
    }
    return () => null;
  });
};

export const useGetNcbOptions = () => {
  const [ncbOptions, setNcbOptions] = useState<any>([]);
  const {
    registrationMonth,
    registrationYear,
    iibLastClaimYear,
    iibLastClaimMonth,
    previousPolicyTypeTpYear
  } = useSelector(({ proposalDataReducer }: any) => {
    return {
      previousPolicyTypeTpYear:
        proposalDataReducer?.data?.previousPolicyTypeTpYear,
      registrationMonth: proposalDataReducer?.data?.registrationMonth,
      registrationYear: proposalDataReducer?.data?.registrationYear,
      iibLastClaimYear: proposalDataReducer?.data?.iibLastClaimYear,
      iibLastClaimMonth: proposalDataReducer?.data?.iibLastClaimMonth
    };
  });
  useEffect(() => {
    let year = registrationYear;
    let month = registrationMonth;
    const currentMonth = new Date().getMonth() + 1;
    if (previousPolicyTypeTpYear) {
      year = Number(previousPolicyTypeTpYear);
      month = currentMonth;
    } else if (iibLastClaimYear) {
      year = Number(iibLastClaimYear) + 1;
      month = registrationMonth || currentMonth;
    }
    const { yearDiff, currentTermYear } = getCurrentTermYearAndDiff(
      year,
      month
    );
    const metaOptions = [...ncbMeta.options!];
    metaOptions.pop();
    const optionsLength = ncbMeta.options!.length;
    const noOptionRanges: number[] = getNoOptionRanges(
      currentTermYear,
      yearDiff
    );
    const startIndex = Math.max(optionsLength - yearDiff - 1, 0);

    const options = metaOptions!
      .slice(startIndex)
      .map((option: JourneyMetaOption, idx: number) => ({
        ...option,
        value: noOptionRanges[idx]
      }));
    // in case user is not eligible for any ncb slab, give option of zero
    if (options.length === 0) {
      options.push({
        value: new Date().getFullYear(),
        name: "0%"
      });
    }
    setNcbOptions(options);
  }, [
    previousPolicyTypeTpYear,
    registrationMonth,
    registrationYear,
    iibLastClaimYear,
    iibLastClaimMonth
  ]);
  return ncbOptions;
};
export { useOnMount, useInitialLoading, useIntersect };
